export const useStyles = (theme) => ({
  userProfileHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "15px 0",
    "& div": {
      marginBottom: 0,
      alignItems: "center",
    },
    "& button": { display: "none" },
  },
});
